import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import './style.css';
import Layout from './Layout';
import Menu from './Menu';
import Providers from '~/providers';
import Cart from './Cart';
import Order from './Order';
import Login from './Login';
import Cashier from './Cashier';
import Report from './Report';
import CashierTransaction from './CashierTransaction';
import Printer from './PrinterV2';
import MenuAvailability from './MenuAvailability';

const App = () => {
  return (
    <BrowserRouter>
      <Providers>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Menu />} />
            <Route path="cart" element={<Cart />} />
            <Route path="order/*" element={<Order />} />
            <Route path="cashier/*" element={<Cashier />} />
            <Route
              path="cashier-transaction/*"
              element={<CashierTransaction />}
            />
            <Route path="report/*" element={<Report />} />
            <Route path="printers" element={<Printer />} />
            <Route path="menu-availability" element={<MenuAvailability />} />
          </Route>
          <Route
            path="/"
            element={
              <div className="container">
                <Outlet />
              </div>
            }
          >
            <Route path="login" element={<Login />} />
          </Route>
        </Routes>
      </Providers>
    </BrowserRouter>
  );
};

export default App;
